export default __webpack_public_path__ + "static/media/img-cycle-4.f346bcaf.png";